/* Template: Mobile subnav
 ========================================================================== */

template.mobile_subnav = function() {

  var $supports_touch = 'ontouchstart' in window || navigator.msMaxTouchPoints,
      $sidebar_dropdown = $('.sidebar__dropdown');

  $sidebar_dropdown.click(function(e) {

      var $this = $(this);
      var mq = template.media_query();


      // if it's child menu is not open, open it
      if (!$this.hasClass('active')) {
          e.preventDefault();
          $this.addClass('active');
      }
      // otherwise just fire the link

  });

};
